import { Action } from '@mirai/ui';
import React from 'react';

import { testDNI } from './testDNI';
import { parseHtml } from '../../helpers';
import { INPUT, INPUT_TYPE } from '../Checkout.constants';
import { L10N } from '../Checkout.l10n';
import * as style from '../Checkout.module.css';

const { HTML, OPTION, PHONE, SELECT } = INPUT;

export const getFieldProps = (
  field = '',
  { input, type, ...rest } = {},
  {
    value,
    error,
    language,
    otherConditions,
    session,
    translate = () => {},
    clubDiscount = 0,
    currency,
    currencyFormat,
  } = {},
  { name = '', url: { conditions = {} } = {} } = {},
  onPress = () => {},
) => {
  const props = Object.fromEntries(Object.entries(rest).filter(([key]) => key !== 'dataSource'));
  const conditionsUrl = conditions[language] || conditions?.en;
  const labelKey =
    field === 'joinClub'
      ? clubDiscount > 0
        ? L10N.LABEL_JOINCLUB_WITH_DISCOUNT
        : L10N.LABEL_JOINCLUB_BENEFITS
      : L10N[`LABEL_${field.toUpperCase()}`];

  return {
    ...props,
    checked: input === OPTION ? (value !== undefined ? value : props.checked) || false : undefined,
    children: input === HTML && props.children ? parseHtml(props.children, { small: true }) : undefined,
    disabled: (field === 'email' && session) || undefined,
    error: field !== 'phone' ? value?.length > 0 && !!error : value?.length > 5 && !!error,
    hint: translate(L10N[`${field.toUpperCase()}_HINT`]),
    id: field ? `checkout-${field.replace(/\./g, '-')}` : undefined,
    key: field,
    label:
      props.label ||
      translate(labelKey, {
        club: name,
        clubLink: (
          <Action href={conditionsUrl} small target="_blank" underline style={{ display: 'inline' }}>
            {translate(L10N.LABEL_TERMS_AND_CONDITIONS)}
          </Action>
        ),
        discount: currencyFormat ? currencyFormat({ currency, value: clubDiscount }) : clubDiscount,
        otherConditions: !!otherConditions,
        termsLink: (
          <Action small onPress={onPress} style={{ display: 'inline' }}>
            {translate(L10N.ACTION_MORE_INFO)}
          </Action>
        ),
      }) ||
      field,
    name: field,
    requiredText: translate(L10N.LABEL_REQUIRED),
    showRequired: true,
    small: [OPTION, HTML].includes(input) || undefined,
    success: field !== 'phone' ? !!value && !error : value?.length > 4 && !error,
    test: field === 'dni' ? testDNI : undefined,
    type:
      type === INPUT_TYPE.NUMBER
        ? 'number'
        : type === INPUT_TYPE.EMAIL
        ? 'email'
        : input === PHONE
        ? 'inputPhone'
        : input === OPTION
        ? 'checkbox'
        : undefined,
    value: input === SELECT && value === undefined ? props.options[0] : value || props.value,
    className: style.wide,
    ...(input === PHONE && { labelPrefix: translate(L10N.LABEL_PHONE_PREFIX) }),
  };
};
